import { render, staticRenderFns } from "./GridHenderSortDom2.vue?vue&type=template&id=16f51bb2&"
import script from "./GridHenderSortDom2.vue?vue&type=script&lang=js&"
export * from "./GridHenderSortDom2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports